
import { supabase } from '@/integrations/supabase/client';

export const saveEmailPin = async (email: string, pin: string): Promise<boolean> => {
  if (!email || !pin) return false;
  
  try {
    const { data: userData } = await supabase.auth.getUser();
    const userId = userData?.user?.id;
    
    const { data, error } = await supabase
      .from('email_pins')
      .upsert({
        email,
        pin,
        user_id: userId || null,
        updated_at: new Date().toISOString()
      })
      .select();
    
    if (error) {
      throw error;
    }
    
    return true;
  } catch (error: any) {
    console.error('Error saving PIN:', error);
    return false;
  }
};

export const verifyEmailPin = async (emailToVerify: string, pinToVerify: string): Promise<boolean> => {
  if (!emailToVerify || !pinToVerify) return false;
  
  try {
    const { data, error } = await supabase
      .from('email_pins')
      .select('pin')
      .eq('email', emailToVerify)
      .maybeSingle();
    
    if (error) {
      throw error;
    }
    
    return data && data.pin === pinToVerify;
  } catch (error) {
    console.error('Error verifying PIN:', error);
    return false;
  }
};

export const checkExistingPin = async (emailToCheck: string): Promise<{exists: boolean; loading: boolean}> => {
  if (!emailToCheck) return { exists: false, loading: false };
  
  try {
    const { data, error } = await supabase
      .from('email_pins')
      .select('pin')
      .eq('email', emailToCheck)
      .maybeSingle();
    
    return { exists: !!data, loading: false };
  } catch (error) {
    console.error('Error checking PIN:', error);
    return { exists: false, loading: false };
  }
};

// Add the missing checkPinExists function
export const checkPinExists = async (email: string): Promise<boolean> => {
  if (!email) return false;
  
  try {
    const { exists } = await checkExistingPin(email);
    return exists;
  } catch (error) {
    console.error('Error checking if PIN exists:', error);
    return false;
  }
};
